import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-primary/80 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Icon name="Sparkles" size={16} />
          <span>Limited Time Offer</span>
        </div>
        
        <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Customer Service?
        </h2>
        
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Book a free automation audit and discover how AI chatbots can save your business 40-70 hours monthly while improving customer satisfaction.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link to="/contact">
            <Button 
              variant="secondary" 
              size="lg" 
              iconName="Calendar" 
              iconPosition="left"
              className="w-full sm:w-auto bg-white text-primary hover:bg-white/90"
            >
              Book Free Audit
            </Button>
          </Link>
          <Button 
            variant="outline" 
            size="lg" 
            iconName="MessageCircle" 
            iconPosition="left"
            className="w-full sm:w-auto border-white text-white hover:bg-white/10"
          >
            Chat on WhatsApp
          </Button>
        </div>
        
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/80 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle2" size={16} />
            <span>No credit card required</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle2" size={16} />
            <span>14-day free trial</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle2" size={16} />
            <span>Setup in 48 hours</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;